export const getSymbolFor = (key: string | symbol): symbol => (typeof key === 'symbol' ? key : Symbol.for(key))
